import { render, staticRenderFns } from "./IndexConsult.vue?vue&type=template&id=fb278438&"
import script from "./IndexConsult.vue?vue&type=script&lang=js&"
export * from "./IndexConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb278438')) {
      api.createRecord('fb278438', component.options)
    } else {
      api.reload('fb278438', component.options)
    }
    module.hot.accept("./IndexConsult.vue?vue&type=template&id=fb278438&", function () {
      api.rerender('fb278438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/documents/IndexConsult.vue"
export default component.exports